import { Filter } from '@/shared/ui/filter';
import { useFilterOptions } from '@/shared/hooks/useFilterOptions';
import { usePickFilterContext } from './pickFilterHooks';
import type { PickFilterDef, PickFilterValue } from '../types';

export function SelectorPickFilterBar() {
  const { filters, values, setFilterValue } = usePickFilterContext();

  return (
    <Filter.Root>
      {filters.map((filter) => (
        <PickFilterSelect
          key={filter.id}
          filter={filter}
          value={values[filter.id]}
          onChange={setFilterValue}
        />
      ))}
    </Filter.Root>
  );
}

interface PickFilterSelectProps {
  filter: PickFilterDef;
  value: PickFilterValue;
  onChange: (id: string, value: PickFilterValue) => void;
}

function PickFilterSelect({ filter, value, onChange }: PickFilterSelectProps) {
  const {
    data: options,
    isLoading,
    isError,
  } = useFilterOptions({
    queryKey: filter.queryKey,
    queryFn: filter.queryFn,
    transform: filter.transform,
    staleTime: filter.staleTime,
    gcTime: filter.gcTime,
    refetchOnMount: filter.refetchOnMount,
  });

  return (
    <Filter.Select
      options={options ?? []}
      value={value as number | null}
      onChange={(next) => onChange(filter.id, next)}
      placeholder={filter.placeholder}
      isLoading={isLoading}
      invalid={isError}
    />
  );
}
